import React from 'react';

function ErrorDisplay({ error, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-surface-950 p-4">
      <div className="max-w-md text-center">
        <div className="inline-block p-5 bg-surface-850 rounded-xl border border-line mb-6">
          <svg className="w-12 h-12 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.998-.833-2.732 0L4.342 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-white mb-2">Something went wrong</h3>
        <p className="text-gray-400 mb-2">{error}</p>
        <p className="text-gray-500 text-sm mb-8">Please try again or contact support if the problem persists</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="btn-primary px-8 py-3"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorDisplay;
